import SingleImgPreview from "canbook-style/ui/edit-image/image_preview/image";
import { useProfileImageState } from "./profile-image-state";

export default function ProfileImageEdit({
  user,
  isImageModalOpen,
  setIsImageModalOpen,
  handleFileUploading,
  removeProfileImage,
  isInLoginFlow,
}: {
  user: {
    name: string | undefined;
    profile_image_url: string | undefined | null;
  };
  isImageModalOpen: boolean;
  setIsImageModalOpen: (isImageModalOpen: boolean) => void;
  handleFileUploading: (file: File | null) => void;
  removeProfileImage: () => void;
  isInLoginFlow?: boolean;
}) {
  const {
    previewFileData,
    setPreviewFileData,
    handleUploadedFile,
    manageRemoveProfileImage,
  } = useProfileImageState(
    user,
    setIsImageModalOpen,
    handleFileUploading,
    removeProfileImage,
  );

  return (
    <>
      <div
        className={`flex flex-col gap-4 items-center ${
          isInLoginFlow ? "" : "shadow-12 dark:shadow-8 rounded-2xl py-6"
        }`}
      >
        <div className="relative h-[104px] w-[104px]">
          <div className="rounded-full flex items-center justify-center h-full w-full bg-container-high">
            <img
              src={previewFileData.previewUrl ?? "/icons/user-profile.svg"}
              alt="Profile"
              className={`object-cover ${
                previewFileData.previewUrl
                  ? "rounded-full h-full w-full"
                  : "invert h-11 w-10"
              }`}
            />
          </div>
          {!previewFileData.previewUrl ? (
            <SingleImgPreview
              uploadedFile={[previewFileData, setPreviewFileData]}
              callback={handleUploadedFile}
            >
              <div className="absolute bottom-3 lg:bottom-0 right-0 h-7 w-7 bg-primary flex justify-center items-center rounded-full cursor-pointer">
                <img
                  src="/icons/edit-outlined.svg"
                  alt="Edit"
                  className="h-3 w-3"
                />
              </div>
            </SingleImgPreview>
          ) : (
            <div
              id="profileImageOption"
              className="absolute bottom-3 lg:bottom-0 right-0 h-7 w-7 bg-primary flex justify-center items-center rounded-full cursor-pointer"
              onClick={() => setIsImageModalOpen(true)}
            >
              <img
                src="/icons/edit-outlined.svg"
                alt="Edit"
                className="h-3 w-3"
              />
            </div>
          )}
        </div>
        <p className="header-2 text-font-primary">{user.name}</p>
      </div>
      {isImageModalOpen && (
        <div
          className="h-screen w-full fixed left-0 top-0 bg-black bg-opacity-50 flex justify-center items-center text-font-primary z-[101]"
          onClick={() => setIsImageModalOpen(false)}
        >
          <div
            id="profileImageOptionModal"
            className="bg-surface p-6 divide-y divide-outline rounded-2xl flex flex-col gap-2"
            onClick={(e) => e.stopPropagation()}
          >
            <SingleImgPreview
              uploadedFile={[previewFileData, setPreviewFileData]}
              callback={handleUploadedFile}
            >
              <p>Change photo</p>
            </SingleImgPreview>
            <p
              className="pt-2 pr-5 cursor-pointer"
              onClick={manageRemoveProfileImage}
            >
              Remove photo
            </p>
          </div>
        </div>
      )}
    </>
  );
}
